import api from './client';

export const getSystems = (projectId) => api.get('/systems', { params: { project: projectId } });
export const createSystem = (data) => api.post('/systems', data);
export const updateSystem = (id, data) => api.put(`/systems/${id}`, data);
export const deleteSystem = (id) => api.delete(`/systems/${id}`);
